import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import _ from 'lodash';
import styled from 'styled-components';
import { translate } from "react-i18next";
import TextInput from '../../../../../components/TextInput';
import SelectInput from '../../../../../components/SelectInput';
import DefaultButton from '../../../../../components/DefaultButton';
import messageManager from '../../../../../utilities/messageManager';
import loading from '../../../../../utilities/loading';
import { modalInstance } from './../../../../admin/Admin';

const TableWrapper = styled.div`
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
`;

const Title = styled.div`
    margin-top: 40px;
    margin-bottom: 20px;
`;

const Table = styled.table`
    height: calc(100% - 4px);
    border-collapse: collapse;
    th {
        text-align: left;
        border-bottom: 2px solid #265a9c;
    };  
    tr {
        font-size: 15px;
    };
    tr:last-child {
        border-bottom: 2px solid #265a9c;
        padding-bottom: 10px;
    };
    tr:last-child>td {
        padding-bottom: 10px;
    };
    td {
        padding: 10px 0 0 10px;
    };
    div {
        display: flex;
        text-align: left;
        align-items: flex-start;
    };
    input[type="date"] {
      width: 156px;
      height: 16px;
    }
`;

const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: row;
    max-height: 30px;
    >div {
        min-width: 60px};
`;

const StyledButton = styled(DefaultButton)`
    min-width: 60px;
`;

const CreatorWrapper = styled.div`
    width: 100%;
    display: flex;
    overflow-x: auto;
    align-items: center;
    input {
        min-width: 300px;
    }
    >div {
        margin-left: 10px;
    }
`;

let dronOnLineInstanceId;
const licenses = [
    { id: 1, name: 'Trial' },
    { id: 2, name: 'Basic' },
    { id: 3, name: 'Professional' },
]

class CustomerAdmin extends React.Component {
    constructor(props) {
        super();
        const dronOnLineInstance = props.instances[0];
        dronOnLineInstanceId = dronOnLineInstance.id;
        this.state = {
            buttonDisabled: false,
            name: '',
            license: { id: 1, name: 'Trial' },
            instance: dronOnLineInstance,
            selectedCustomerId: 0,
            editedName: '',            
            prevName: '',
            editedLicenseId: 1,
            prevLicenseId: 1,            
            editedLicenseValidityEnd: '',
            prevLicenseValidityEnd: '',
            editedInstanceId: dronOnLineInstanceId,
            prevInstanceId: dronOnLineInstanceId,
        }
    }

    createCustomer() {
        const { BASE_URL, axiosInstance, t, getCustomers } = this.props;
        const { name, license, instance } = this.state;
        this.setState({ buttonDisabled: true });

        loading.start();
        axiosInstance.post(`${BASE_URL}customers`,
            {
                name: name,
                licenseId: Number(license.id),
                instanceId: Number(instance.id)
            })
            .then(() => {
                getCustomers();
                messageManager.show({
                    type: 'info',
                    text: t('Customer created'),
                });
                this.setState({ buttonDisabled: false })
                loading.stop();
            })
            .catch((error) => {
                messageManager.show({
                    type: 'error',
                    text: t(error.response.data ? error.response.data : t('Error occured while deleting customer')),
                });
                this.setState({ buttonDisabled: false })
                loading.stop();
            });
    }

    editCustomer(e) {
        const { BASE_URL, axiosInstance, t, getCustomers, customers } = this.props;
        const { editedName, prevName, editedLicenseId, selectedCustomerId, editedLicenseValidityEnd, editedInstanceId } = this.state;
        const name = editedName === '' ? prevName : editedName;

        this.setState({ buttonDisabled: true });
        loading.start();

        const selectedCustomer = customers.find(customer => customer.id === Number(selectedCustomerId));
        const editedCustomer = _.cloneDeep(selectedCustomer);
        editedCustomer.name = name;
        editedCustomer.licenseId = Number(editedLicenseId);
        editedCustomer.licenseValidityEnd = editedLicenseValidityEnd;
        editedCustomer.instanceId = editedInstanceId;
        delete editedCustomer.license;
        delete editedCustomer.instance;

        axiosInstance.put(`${BASE_URL}customers/${selectedCustomerId}`, editedCustomer)
            .then(() => {     
                axiosInstance.get(`${BASE_URL}customers/${selectedCustomerId}`)
                    getCustomers();
                    this.setState({ 
                        buttonDisabled: false, 
                        editedName: '', 
                        editedLicenseId: 1, 
                        selectedCustomerId: 0,
                        editedInstanceId: dronOnLineInstanceId
                    })
                    loading.stop();
                    messageManager.show({
                        type: 'info',
                        text: t('Customer edited'),
                    })
                    
                })
            .catch((error) => {
                messageManager.show({
                    type: 'error',
                    text: t(error.response.data ? error.response.data : t('Error occured while editing customer')),
                });
                this.setState({ 
                    buttonDisabled: false, 
                    editedName: '', 
                    editedLicenseId: 1, 
                    selectedCustomerId: 0,
                    editedInstanceId: dronOnLineInstanceId
                })
                loading.stop();
            });
    }
   
    deleteCustomer(customerId) {
        const { BASE_URL, axiosInstance, t, getCustomers, customers } = this.props;
        this.setState({ buttonDisabled: true });

        loading.start();      
        const selectedCustomer = customers.find(customer => customer.id === Number(customerId));
        const confirmCallback = () => {
            axiosInstance.delete(`${BASE_URL}customers/${selectedCustomer.id}`)
                .then((response) => {
                    getCustomers();
                    messageManager.show({
                        type: 'info',
                        text: t('Customer deleted'),
                    });
                    this.setState({ buttonDisabled: false });
                    loading.stop();
                })
                .catch((error) => {
                    messageManager.show({
                        type: 'error',
                        text: t(error.response.data ? error.response.data : t('Error occured while deleting customer')),
                    });
                    this.setState({ buttonDisabled: false });
                    loading.stop();
                });
        }

        const cancelCallback = () => {
            this.setState({ buttonDisabled: false });
            loading.stop();
        }

        const config = {
            title: t('Do you really want to delete customer') + '?',
            content: <p>{t('Do you really want to delete customer')} <b>{String(selectedCustomer.name)}</b>? {t('All projects and users related with customer will be lost')}</p>,
            confirmCallback: confirmCallback,
            cancelCallback: cancelCallback,
            confirmBtnVisible: true,
            cancelBtnVisible: true,
            confirmBtnText: t('Delete'),
            closeOnConfirm: true,
            type: 'warning',
        }

        modalInstance.customize(config);
        modalInstance.show();
    }

    getCustomerList() {
        const { instances, customers, t } = this.props;
        const { buttonDisabled, selectedCustomerId, editedName, prevName, editedLicenseId, prevLicenseId,
            editedLicenseValidityEnd, prevLicenseValidityEnd, editedInstanceId, prevInstanceId } = this.state;
        const customerList = customers.map((customer) =>
            <tr key={customer.id}>
                <td>
                     <TextInput
                        placeholder={customer.name}
                        value={selectedCustomerId === customer.id ? editedName : customer.name}
                        onChange={(e) => {this.setState({ editedName: e.target.value })}}
                        disabled={selectedCustomerId !== customer.id}/>
                </td>
                <td>
                    <SelectInput
                        value={selectedCustomerId === customer.id ? editedLicenseId : customer.license.id}
                        onChange={(e) => { this.setState({ editedLicenseId: e.target.value }) }}
                        disabled={selectedCustomerId !== customer.id}
                    >
                        {licenses.map(license => {
                            return (
                                <option
                                    key={`${license.id} _license`}
                                    value={license.id}
                                >
                                    {license.name}
                                </option>
                            )
                        })}
                    </SelectInput>
                </td>
                <td>                
                    <TextInput
                        value={selectedCustomerId === customer.id ? 
                            editedLicenseValidityEnd ? editedLicenseValidityEnd.substring(0, 10) : t('Unlimited') :
                            customer.licenseValidityEnd ? customer.licenseValidityEnd.substring(0, 10) : t('Unlimited')}
                        onChange={(e) => { this.setState({ editedLicenseValidityEnd: e.target.value }) }}
                        disabled={selectedCustomerId !== customer.id}
                        type={selectedCustomerId === customer.id || customer.licenseValidityEnd ? 'date' : 'text'} />
                </td>
                <td>
                    <SelectInput
                        value={selectedCustomerId === customer.id ? editedInstanceId : customer.instanceId}
                        onChange={(e) => { this.setState({ editedInstanceId: e.target.value }) }}
                        disabled={selectedCustomerId !== customer.id}
                    >
                        {instances.map(instance => {
                            return (
                                <option
                                    key={`${instance.id} _instance`}
                                    value={instance.id}
                                >
                                    {instance.name}
                                </option>
                            )
                        })}
                    </SelectInput>
                </td>
                <td>
                    <ButtonWrapper>
                        {selectedCustomerId === customer.id
                            ? <StyledButton
                                    disabled={buttonDisabled}
                                    onClick={this.editCustomer.bind(this)}>
                                    {t('Save')}
                                </StyledButton>
                            : <StyledButton
                                    disabled={buttonDisabled}
                                    onClick={(e) => {
                                        this.setState({ 
                                            selectedCustomerId: customer.id, 
                                            editedName: '',
                                            prevName: customer.name,
                                            editedLicenseId: customer.license.id,
                                            prevLicenseId: customer.license.id,
                                            editedLicenseValidityEnd: customer.licenseValidityEnd,
                                            prevLicenseValidityEnd: customer.licenseValidityEnd,
                                            editedInstanceId: customer.instanceId,
                                            prevInstanceId: customer.instanceId})}}>
                                    {t('Edit')}
                                </StyledButton>}
                        {selectedCustomerId === customer.id
                            ? <StyledButton
                                    type='warning'
                                    disabled={buttonDisabled}
                                    onClick={(e) => {this.setState({ 
                                        selectedCustomerId: 0, 
                                        editedName: prevName,
                                        editedLicenseId: prevLicenseId,
                                        editedLicenseValidityEnd: prevLicenseValidityEnd,
                                        editedInstanceId: prevInstanceId})}}>
                                    {t('Cancel')}
                                </StyledButton>
                            : <StyledButton
                                    type='warning'
                                    disabled={buttonDisabled}
                                    onClick={() => this.deleteCustomer(customer.id)}>
                                    {t('Delete')}
                                </StyledButton>}     
                    </ButtonWrapper>
                </td>
            </tr>
        )

        return <Table>
                <thead>
                    <tr>
                        <th>{t('Name')}</th>
                        <th>{t('License')}</th>
                        <th>{t('License validity')}</th>
                        <th>{t('Instance')}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {customerList}
                </tbody>
            </Table>
    }

    render() {
        const { t, customers, instances } = this.props;
        const { license, name, instance } = this.state;

        return (
            <React.Fragment>
                {customers.length > 0
                    ? <React.Fragment>
                        <Title style={{marginTop: '20px'}}>{t('Manage customers')}:</Title>
                        <TableWrapper> {this.getCustomerList()} </TableWrapper>
                    </React.Fragment>
                    : null}
                <Title>{t('Create new customer')}:</Title>
                <CreatorWrapper>
                    <TextInput
                        placeholder={t('New Customer')+'...'}
                        value={name}
                        onChange={(e) => {
                            this.setState({ name: e.target.value })
                        }}/>
                    <SelectInput
                        value={license.id}
                        onChange={(e) => {
                            this.setState({ license: licenses.find(license => Number(license.id) === Number(e.target.value)) })
                        }}
                    >
                        {licenses.map(license => {
                            return (
                                <option
                                    key={`${license.id} _license`}
                                    value={license.id}
                                >
                                    {license.name}
                                </option>
                            )
                        })}
                    </SelectInput>
                    <SelectInput
                        value={instance.id}
                        onChange={(e) => {
                            this.setState({ instance: instances.find(instance => Number(instance.id) === Number(e.target.value)) })
                        }}
                    >
                        {instances.map(instance => {
                            return (
                                <option
                                    key={`${instance.id} _instance`}
                                    value={instance.id}
                                >
                                    {instance.name}
                                </option>
                            )
                        })}
                    </SelectInput>
                    <ButtonWrapper>
                        <DefaultButton
                            onClick={(e) => {this.createCustomer()}}
                            disabled={this.state.buttonDisabled}
                        >
                            {t('Create')}
                        </DefaultButton>
                    </ButtonWrapper>
                </CreatorWrapper>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(CustomerAdmin));



// WEBPACK FOOTER //
// ./src/containers/content/grid/adminPanel/customerAdmin/CustomerAdmin.jsx